import { ApplicationInsights } from '@microsoft/applicationinsights-web';

let appInsights: ApplicationInsights | null = null;

export function initTelemetry(): void {
	const connectionString = process.env.APPLICATIONINSIGHTS_CONNECTION_STRING;

	if (!connectionString) {
		return;
	}

	appInsights = new ApplicationInsights({
		config: {
			connectionString,
			enableAutoRouteTracking: true,
			disableAjaxTracking: true,
			disableFetchTracking: true,
		},
	});

	appInsights.loadAppInsights();
}

export function trackException(error: Error, properties?: Record<string, string>): void {
	appInsights?.trackException({ exception: error }, properties);
}

export function getAppInsights(): ApplicationInsights | null {
	return appInsights;
}
